import React, { useEffect } from 'react';

import confetti from 'canvas-confetti';
import { useHistory } from 'react-router-dom';

import styles from './style.module.scss';

const AnniversaryPicks: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    const confettiInterval = setInterval(() => {
      confetti({
        particleCount: 8,
        startVelocity: 20,
        spread: 80,
        origin: {
          x: Math.random() * 0.6 + 0.2,
          y: Math.random() * 0.4,
        },
        colors: ['#facc15', '#4ade80', '#ffffff'],
      });
    }, 1500);

    return () => clearInterval(confettiInterval);
  }, []);

  const stockPicks = [
    {
      label: '📌 Stock #1',
      ticker: 'RGTI',
      name1: '🚀 2-Week Gain',
      value1: '+21.64%',
      name2: '📉 Rebound from 52W Low',
      value2: '+2,045%',
      name3: '📊 Institutional Holding',
      value3: '↑ past 6 Qtrs',
      pickNote:
        '💡 RGTI is gaining explosive momentum with 6 straight Qtrs of institutional growth and fresh entries from Morgan Stanley and Citadel.',
    },
    {
      label: '📌 Stock #2',
      ticker: 'SE',
      name1: '🚀 YTD %',
      value1: '+54%',
      name2: '📉 Rebound from 52W Low',
      value2: '+200%',
      name3: '📊 Institutional Holding',
      value3: '↑ past 5 Qtrs',
      pickNote:
        '💡 SE shows breakout potential with solid institutional backing and technical recovery.',
    },
    {
      label: '📌 Stock #3',
      ticker: 'CRVS',
      name1: '🚀 1-Year Price in%',
      value1: '+82.38%',
      name2: '📉 Rebound from 52W Low',
      value2: '+116%',
      name3: '📊 Institutional Holding',
      value3: '↑ past 3 Qtrs',
      pickNote:
        '💡 CRVS shows insider conviction—CEO & President bought ~$1M in shares recently.',
    },
    {
      label: '📌 Stock #4',
      ticker: 'AFRM',
      name1: '🚀 1-Year Price in%',
      value1: '+82%',
      name2: '📉 Rebound from 52W Low',
      value2: '+128%',
      name3: '📊 Institutional Holding',
      value3: '↑ past 3 Qtrs',
      pickNote:
        '💡 AFRM is attracting steady fund inflows—Citadel has built a $140M position.',
    },
    {
      label: '📌 Stock #5',
      ticker: 'PLTR',
      name1: '🚀 1-Year Price in%',
      value1: '+499%',
      name2: '🧾 Hedge Funds',
      value2: 'D.E. Shaw Purchased $998.485M',
      name3: '📊 Institutional Holding',
      value3: '↑ past 8 Qtrs',
      pickNote:
        '💡 PLTR boasts 8 Qtrs of institutional inflows and ~$1B interest from D.E. Shaw.',
    },
    {
      label: '📌 Stock #6',
      ticker: 'BBAI',
      name1: '🚀 1-Year Price in%',
      value1: '+171%',
      name2: '📉 Rebound from 52W Low',
      value2: '+279%',
      name3: '📊 Total Institutional Shares',
      value3: '58,963,445',
      pickNote:
        '💡 BBAI is gaining steam with 3 Qtrs of institutional growth and a $12M stake from Millennium Management.',
    },
    {
      label: '📌 Stock #7',
      ticker: 'UPST',
      name1: '🚀 1-Year Price in%',
      value1: '+104%',
      name2: '📉 Rebound from 52W Low',
      value2: '+128%',
      name3: '📊 Total Institutional Shares',
      value3: '59,226,192',
      pickNote:
        '💡 UPST is back on fund radars with over 59M shares held—new positions include Renaissance Technologies.',
    },
  ];

  return (
    <div className={styles.container}>
      <h1 className={`${styles.heading} ${styles.gradientText}`}>
        7 Years of Vision, 7 Stocks of Value
      </h1>
      <p className={styles.subheading}>
        Celebrating 7 years of market wisdom — these 7 high-conviction stock
        picks are backed by smart money flows, technical strength, and insider
        confidence.
      </p>

      <div className={styles.gridRow}>
        {stockPicks.slice(0, 4).map((stock, i) => (
          <div className={styles.card} key={i}>
            <h2
              onClick={() => history.push(`/reports/isr/${stock.ticker}`)}
              style={{ cursor: 'pointer' }}
            >
              {stock.label}:{' '}
              <span className={styles.ticker}>{stock.ticker}</span>
            </h2>
            <ul>
              <li>
                {stock.name1}: {stock.value1}
              </li>
              <li>
                {stock.name2}: {stock.value2}
              </li>
              <li>
                {stock.name3}: {stock.value3}
              </li>
            </ul>
            <p className={styles.note}>{stock.pickNote}</p>
          </div>
        ))}
      </div>

      <div className={styles.gridRowLast}>
        {stockPicks.slice(4, 7).map((stock, i) => (
          <div className={styles.card} key={i + 4}>
            <h2
              onClick={() => history.push(`/reports/isr/${stock.ticker}`)}
              style={{ cursor: 'pointer' }}
            >
              {stock.label}:{' '}
              <span className={styles.ticker}>{stock.ticker}</span>
            </h2>
            <ul>
              <li>
                {stock.name1}: {stock.value1}
              </li>
              <li>
                {stock.name2}: {stock.value2}
              </li>
              <li>
                {stock.name3}: {stock.value3}
              </li>
            </ul>
            <p className={styles.note}>{stock.pickNote}</p>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        Insights from ThinkSabio’s Smart Money Signal System
        <br />
        <strong>Sincere Thanks to Thinksabiens 💚</strong>
      </div>
    </div>
  );
};

export default AnniversaryPicks;
